import { Box, Stack, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { Formik, Form } from 'formik';
import { AppFormikButtonTiles } from 'shared/components/AppComponents';
import MCPGuardTrail from './mcp-guard/MCPGurardTrail';
import ServerList from './servers/ServerList';
import APIKeyList from './api-keys/ApiKey';
import ToolGovernance from './tool-governance/ToolGovernance';
import AuditLogs from './audit-logs/AuditLogs';
import ProxyPage from './proxy-setting/ProxyPage';
import PromptPolicies from '../promptPolicies/Main';

interface GuardrailsFormValues {
  status: boolean[];
}

function GuardrailsList(): ReactElement {
  const getInitialTab = (): boolean[] => [
    true,
    false,
    false,
    false,
    false,
    false,
    false,
  ];

  const initialValues: GuardrailsFormValues = {
    status: getInitialTab(),
  };

  return (
    <Box className="guardrails-wrapper">
      <Stack className="guardrails-container" direction="column">
        <Formik
          initialValues={initialValues}
          onSubmit={() => console.log('test')}
        >
          {({ values }) => (
            <Form style={{ width: '100%' }}>
              <Box>
                <AppFormikButtonTiles
                  variant="outlined"
                  name="status"
                  size="small"
                  label=""
                  disabled={false}
                  multichoice={false}
                  className="app-group-button"
                  buttons={[
                    {
                      value: 'Prompt Policies',
                      tooltip:
                        'Define and enforce safety, compliance, and content guardrails for LLM inputs and outputs.',
                    },
                    {
                      value: 'MCP Proxy',
                      tooltip:
                        'Manage, route, and secure MCP connections between clients and servers.',
                    },
                    {
                      value: 'Servers',
                      tooltip:
                        'Configure and monitor registered infrastructure, hosting nodes, and backend AI environments.',
                    },
                    {
                      value: 'API Keys',
                      tooltip:
                        'Provision, inspect, and rotate access credentials for external AI providers and internal integrations.',
                    },
                    {
                      value: 'Tool Governance',
                      tooltip:
                        'Set access controls, execution limits, and permissions for tools accessible by AI agents.',
                    },
                    {
                      value: 'Audit Log',
                      tooltip:
                        'Track real-time security events, admin actions, policy violations, and historical system activity.',
                    },
                    {
                      value: 'Proxy Settings',
                      tooltip:
                        'Configure network parameters, authentication controls, and routing traffic for enterprise requests.',
                    },
                  ]}
                  outerLabel
                />
              </Box>

              {values.status[0] && (
                <>
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={2}
                    className="mt-7 mx-3 mb-4"
                  >
                    <img height={25} src="/images/icons/IconShield.svg" />
                    <Typography variant="h5" className="fw-7 f28">
                      Policy Manager
                    </Typography>
                  </Stack>
                  <PromptPolicies />
                </>
              )}
              {values.status[1] && <MCPGuardTrail />}

              {values.status[2] && <ServerList />}

              {values.status[3] && <APIKeyList />}

              {values.status[4] && <ToolGovernance />}

              {values.status[5] && <AuditLogs />}

              {values.status[6] && <ProxyPage />}
            </Form>
          )}
        </Formik>
      </Stack>
    </Box>
  );
}

export default GuardrailsList;
